const isVisible = (element) => {
  var _a;
  if (!(element instanceof Element)) {
    throw Error("You must provide a DOM element.");
  }
  return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length) && window.getComputedStyle(element).visibility !== "hidden" && window.getComputedStyle(element).display !== "none" && ((_a = element.style) == null ? void 0 : _a.transform.includes("translateY(-9999px)")) === false;
};
const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed) => {
  const listLength = list.length;
  let index = activeElement ? list.indexOf(activeElement) : -1;
  if (index === -1) {
    return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
  }
  index += shouldGetNext ? 1 : -1;
  if (isCycleAllowed) {
    index = (index + listLength) % listLength;
  }
  return list[Math.max(0, Math.min(index, listLength - 1))];
};
const isElement = (el) => {
  return typeof el === "object" && el !== null && "tagName" in el && el instanceof HTMLElement;
};
export {
  getNextActiveElement,
  isElement,
  isVisible
};
